import { compose, withState, withHandlers } from "recompose";
import { graphql } from "react-apollo";
import makeCommandDispatcher from "web/core/apollo/makeCommandDispatcher";
import SetCurrencyMutation from "./SetCurrencyMutation.gql";
import { injectIntl, defineMessages } from "react-intl";

const messages = defineMessages({
  error: {
    id: "modules.User.CurrencySelector",
    defaultMessage:
      "An error occurred while switching to this currency. Please try again or contact us.",
  },
});

const withCurrencies = ({ CurrencySelectorQuery }) =>
  compose(
    graphql(CurrencySelectorQuery, {
      props: ({ data, ownProps }) => {
        return {
          loading: data.loading,
          currency: data?.shop?.currentCurrency || ownProps.currency || null,
          availableCurrencies: data?.shop?.availableCurrencies || null,
        };
      },
    })
  );

const withCurrencyMutation = () =>
  compose(
    injectIntl,
    withState("error", "setError", null),
    withState("selectedCurrency", "setSelectedCurrency", null),
    makeCommandDispatcher({
      selectCurrency: (props) => (input) => {
        return {
          options: {
            mutation: SetCurrencyMutation,
            variables: {
              input: input,
            },
          },
          callback: ({ status, data }) => {
            if (status === "success") {
              window.location.reload();
            } else {
              props.setError(props.intl.formatMessage(messages.error));
            }
          },
        };
      },
    }),
    withHandlers({
      selectCurrency: (props) => (input) => {
        props.setSelectedCurrency(input.currency);
        return props.selectCurrency(input);
      },
    })
  );

const EnhanceCurrencySelector = ({ CurrencySelectorQuery }) =>
  compose(withCurrencies({ CurrencySelectorQuery }), withCurrencyMutation());

export default EnhanceCurrencySelector;
